import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { SITE } from "@/data/site";

const links = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Loan Products" },
  { to: "/emi-calculator", label: "EMI Calculator" },
  { to: "/eligibility", label: "Eligibility" },
  { to: "/track", label: "Track Status" },
  { to: "/partnership", label: "Partners" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="navbar"
      className="fixed top-0 inset-x-0 z-50 nav-glass bg-[hsl(40_33%_98%/0.72)] border-b border-black/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5 group shrink-0">
          <img src={SITE.logo} alt="Rightway Finance" className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover ring-1 ring-emerald-800/10 shadow-sm"/>
          <span className="hidden xl:flex flex-col leading-none whitespace-nowrap">
            <span className="font-display text-lg tracking-tight text-slate-900">Rightway Finance</span>
            <span className="font-mono text-[9px] tracking-[0.24em] uppercase text-slate-500 mt-1">Since {SITE.since}</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-5 text-sm">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace('/', '') || 'home'}`}
              className={({ isActive }) =>
                `relative whitespace-nowrap transition-colors ${isActive ? "text-emerald-800" : "text-slate-700 hover:text-slate-900"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a href={`tel:${SITE.phoneRaw}`} target="_top" rel="noopener" data-testid="nav-call-btn" className="hidden xl:inline-flex whitespace-nowrap items-center gap-2 text-sm text-slate-700 hover:text-emerald-800 transition-colors">
            <Phone size={16} /> {SITE.phone}
          </a>
          <Link
            to="/apply"
            data-testid="nav-apply-btn"
            className="hidden md:inline-flex btn-line whitespace-nowrap items-center gap-1 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white text-sm px-5 py-2.5 transition-colors"
          >
            Apply for a Loan
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 rounded-full hover:bg-black/5"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-black/[0.06] bg-white/95 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `py-3 px-3 rounded-xl text-base ${isActive ? 'bg-emerald-50 text-emerald-800' : 'text-slate-800 hover:bg-black/5'}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/apply" onClick={() => setOpen(false)} className="mt-2 text-center rounded-full bg-emerald-700 text-white py-3">Apply for a Loan</Link>
          </div>
        </div>
      )}
    </header>
  );
}
